export const isSuperadmin = (profile) => profile?.role === 'superadmin';

export const isProdiAdmin = (profile) => profile?.role === 'admin_prodi';

export const getCriteriaRoleCode = (profile) => {
  const role = String(profile?.role || '').toLowerCase();
  return /^c\d+$/.test(role) ? role.toUpperCase() : null;
};

export const formatRoleLabel = (roleOrProfile) => {
  const role = typeof roleOrProfile === 'string'
    ? roleOrProfile
    : roleOrProfile?.role;
  const normalizedRole = String(role || '').toLowerCase();

  if (/^c\d+$/.test(normalizedRole)) {
    return `TEAM ${normalizedRole.toUpperCase()}`;
  }

  if (normalizedRole === 'admin_prodi') return 'Admin Prodi';
  if (normalizedRole === 'superadmin') return 'Superadmin';

  return role || '-';
};

export const canAccessCriteria = (profile, criteriaCode) => {
  if (!profile) return false;
  if (isSuperadmin(profile) || isProdiAdmin(profile)) return true;
  return getCriteriaRoleCode(profile) === criteriaCode;
};

export const getCriteriaScope = (profile, criteriaConfig) => {
  if (!profile) return [];
  if (isSuperadmin(profile) || isProdiAdmin(profile)) return criteriaConfig;
  const criteriaRoleCode = getCriteriaRoleCode(profile);
  return criteriaConfig.filter((criteria) => criteria.code === criteriaRoleCode);
};

export const shouldFilterByProfileProdi = (profile) => !isSuperadmin(profile);
